import {EnumValidValueModel} from '../enum/enum-valid-value.model';
import {FormMasterItemConfigurationModel} from './form-master-item-configuration.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {FormItemActionConfigurationModel} from './form-item-action-configuration.model';
import {FormItemCalculationConfigurationModel} from './form-item-calculation-configuration.model';
import {XauditModel} from '../xaudit.model';

export class FormItemConfigurationModel extends XauditModel {
    DFormItemId: string;
    DFormParagraphId: string;
    DFormItemName: string;
    DFormMasterItemId: string;
    ParentDFormItemId: string;
    HasChildren: boolean;
    enumFormControlID: string;
    ItemOrder: number;
    ParagraphRow: number;
    ParagraphColumn: number;
    ParagraphRowHeight: number;
    ParagraphColumnWidth: number;
    FormControlColumnSpan: number;
    Label: string;
    LabelWidth: number;
    PostLabel: string;
    ValidValueId: string;
    BeforeDisplay_ItemActionId: string;
    AfterUpdate_ItemActionId: string;
    DefaultValue: string;
    isBreakAfterItem: boolean;
    isReadOnlyForPatient: boolean;
    isRequired: boolean;
        
    CalculationID: string;
    isNoteEnabled: boolean;
    isDocumentEnabled: boolean;
    enumLabelAligmentID: string;
    enumPostLabelAligmentID: string;
    Calculation: FormItemCalculationConfigurationModel;
    BeforeDisplayItemAction: FormItemActionConfigurationModel;
    AfterUpdateItemAction: FormItemActionConfigurationModel;
    ValidValue: EnumValidValueModel;
    ChildDFormItems: FormItemConfigurationModel[];
    cfgDFormMasterItem: FormMasterItemConfigurationModel;
    enumFormControl: EnumValidValueItemModel;
    enumLabelAligment: EnumValidValueItemModel;
    enumPostLabelAligment: EnumValidValueItemModel;

    NoteTriggerValidValueItemId: string;
    Note: string;
    IncludeValueInNote: boolean;
}
